import { observer } from 'mobx-react';
import React from 'react';
import { IPageWithLayoutProperties } from '../../../../view/layout/page/IPageWithLayoutProperties';

export interface ImportDataMainPageProperties extends IPageWithLayoutProperties {}

export const ImportDataMainPage = observer(({ layoutDomain }: ImportDataMainPageProperties) => {
  return <></>;
});
